import { render, staticRenderFns } from "./gmToolNewgift.vue?vue&type=template&id=ef46144c&"
import script from "./gmToolNewgift.vue?vue&type=script&lang=js&"
export * from "./gmToolNewgift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef46144c')) {
      api.createRecord('ef46144c', component.options)
    } else {
      api.reload('ef46144c', component.options)
    }
    module.hot.accept("./gmToolNewgift.vue?vue&type=template&id=ef46144c&", function () {
      api.rerender('ef46144c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/gift/gmToolNewgift.vue"
export default component.exports